import { HTTP_POST, WebApiRequest } from "tools/webservice";

export const startMuellerSelectProcess = (controlIdNumber, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: `/mueller-select/case/${controlIdNumber}/start-process`,
  successCallback,
  errorCallback,
  mountedRef,
});